import * as amplitude from "@amplitude/analytics-browser";
import { createContext } from "react";

import { type Ampli, ampli } from "@/ampli";

type TrackingState = {
  ampli: Ampli;
};

export const setupAmpli = (apiKey: string): Ampli => {
  const enabled: boolean = Boolean(apiKey && apiKey !== "tracking-key-goes-here");

  if (enabled) {
    amplitude.init(apiKey, "", {
      autocapture: {
        pageViews: true,
        sessions: true,
      },
    });
  }
  ampli.load({ disabled: !enabled, client: { instance: amplitude } });
  return ampli;
};

export const TrackingContext = createContext<TrackingState>({
  ampli,
});

type Props = {
  ampli: Ampli;
};

const TrackingStateProvider = ({ ampli }: Props) => {
  const trackingState: TrackingState = {
    ampli,
  };
  return <TrackingContext.Provider value={trackingState} />;
};

export default TrackingStateProvider;
